import { render, staticRenderFns } from "./DataBusiness.vue?vue&type=template&id=2b5f4c9f&scoped=true&"
import script from "./DataBusiness.vue?vue&type=script&lang=js&"
export * from "./DataBusiness.vue?vue&type=script&lang=js&"
import style0 from "./DataBusiness.vue?vue&type=style&index=0&id=2b5f4c9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5f4c9f",
  null
  
)

export default component.exports